export default {
  projects: [
    {
      name: "Ułatwiaczek",
      description: "Application for calculating exam tasks difficulty",
      link: "https://github.com/Marucik/Ulatwiaczek"
    },
    {
      name: "Absolwenci.PRO",
      description: "School graduates database",
      link: "https://github.com/Dawiducik/Absolwenci.pro",
      live: "http://absolwenci.zstmielec.pl/"
    },
    {
      name: "Vue_XO",
      description: "Simple Tic Tac Toe game based on Vue and Sockets",
      link: "https://github.com/Marucik/vue_XO",
      live: "https://marucik.github.io/vue_XO/"
    },
    {
      name: "JS-calculator",
      description: "Simple calculator",
      link: "https://github.com/Marucik/JS-calculator",
      live: "https://marucik.github.io/JS-calculator/"
    },
    {
      name: "JS-ASCII-Clock",
      description: "Clock in ASCII style",
      link: "https://github.com/Marucik/JS-ASCII-Clock/",
      live: "https://marucik.github.io/JS-ASCII-Clock/"
    }
  ],
  tech: [
    "JavaScript",
    "HTML 5",
    "CSS 3",
    "SQL",
    "C++",
    "C#",
    "Node.js",
    "Vue",
    "Git",
    "MongoDB",
    "PHP"
  ]
};
